export interface IWsNoticias {
	IdNoticia?: number;
	Titulo: string;
	Fecha?: string;
	Autor: string;
	Resumen?: string;
	Contenido: string;
	Imagen?: string;
	Visitas?: number;
	Tags?: string;
}

export class WsNoticias {
	IdNoticia?: number;
	Titulo: string;
	Fecha?: string;
	Autor: string;
	Resumen?: string;
	Contenido: string;
	Imagen?: string;
	Visitas?: number;
	Tags?: string[];
	IdUsuario: number;
	// Auxiliares
	sTags?: string;
	toggle: boolean;

	constructor(data?: any) {
		if (data) {
			this.IdNoticia = data.IdNoticia;
			this.Titulo = data.Titulo;
			this.Fecha = data.Fecha;
			this.Autor = data.Autor;
			this.IdUsuario = data.IdUsuario;
			this.Resumen = data.Resumen;
			this.Contenido = data.Contenido;
			this.Imagen = data.Imagen;
			this.Visitas = data.Visitas;
			this.sTags = data.Tags && typeof data.Tags === 'object' ? data.Tags.join(', ') : data.Tags;
			this.Tags = data.Tags && typeof data.Tags === 'string' ? data.Tags.split(',').map(t => t.trim()).filter(t => t) : data.Tags || [];
		}
	}
}
